import React from 'react'
import { useSelector } from 'react-redux'
import { useOnFavoriteClick } from 'cityads-v3/hooks/offers';
import { RootState } from 'cityads-v3/types/reducer'

import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';
import IconButton, { IconButtonProps } from '@mui/material/IconButton'


type FavoriteButtonProps = IconButtonProps & {
  offerId: number,
  onFavClick?(): void,
  onComplete?(): void,
}

const FavoriteButton: React.FC<FavoriteButtonProps> = function ({ offerId, onFavClick, onComplete, ...rest }) {
  const isFavorite = useSelector((state: RootState) => Boolean(state.offers.offerFavoritesByOfferId[offerId]));
  const favoriteState = useSelector((state: RootState) => state.offers.offerFavoritesStateByOfferId[offerId]);
  const handleClick = useOnFavoriteClick(offerId, onFavClick, onComplete) as () => void;

  return (
    <IconButton
      size="large"
      {...rest}
      sx={[
        ...Array.isArray(rest.sx) ? rest.sx : [rest.sx],
        theme => ({
          color: isFavorite
            ? theme.palette.mode === 'light'
              ? theme.palette.primary.main
              : theme.palette.text.primary
            : undefined
        })
      ]}
      disabled={favoriteState !== 'ready'}
      onClick={handleClick}
    >
      {isFavorite ? <FavoriteOutlinedIcon /> : <FavoriteBorderOutlinedIcon />}
    </IconButton>
  )
}

export default FavoriteButton;
